module.exports = __webpack_public_path__ + "static/media/vf_wknit_core.e9a0ba1d.svg";